<template>
  <v-select
    :key="props.id"
    :id="props.field"
    :error="error"
    :data-cy="props.id.split('_')[1] + '-' + props.field"
    v-bind="$attrs"
    ref="inputField"
    v-model="value"
    :hide-spin-buttons="true"
    :label="hideLabel ? '' : label || t(`entities.${type}.fields.${field}`)"
    :readonly="readonly"
    :class="{ occupied: isOccupied }"
    role="CalcInput"
    :items="items"
    @update:focused="watchFocus"
    @wheel="() => inputField?.blur()"
    @update:menu="onChangeMenu">
    <!--TODO readonly not clickable-->
    <template
      v-if="props.icon"
      #prepend>
      <icon-loader :name="props.icon" />
    </template>
    <v-avatar
      size="20"
      v-if="isOccupied"
      color="primary"
      style="position: fixed; right: 10px; top: 10px; font-size: 12px">
      {{ mainStore.getInitials(isOccupied) }}
    </v-avatar>
  </v-select>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, toRef } from "vue";
import IconLoader from "@/components/tools/IconLoader.vue";
import { useMainStore } from "@/stores/mainStore";
import { useCalcInput } from "./calcInputComposable";

const copyName = () => {
  navigator.clipboard.writeText(`,"${props.field}"`);
};

const mainStore = useMainStore();

const { t } = useTranslation();

const props = defineProps<{
  id: string;
  field: string;
  hideLabel: boolean;
  readonly: boolean;
  icon: string | null;
  label: string | null;
  items: { title: string; value: string }[] | string[];
}>();

const [_, type] = props.id.split("_");

function onChangeMenu(value: boolean) {
  console.log("onChangeMenu called with value:", value, inputField.value);
  !value && inputField.value && inputField.value.blur();
}

const items = computed(() => {
  return props.items.map((item) => {
    return {
      title: item.title || item,
      value: item.value || item,
      props: { "data-cy": `select-option-${item.value}` }
    };
  });
});

const { inputField, isOccupied, error, watchFocus, value, readonly } =
  useCalcInput(
    toRef(() => props.id),
    toRef(() => props.field),
    props.readonly
  );
</script>
<style scoped lang="scss">
.calc-input {
  /* Add your styles here */
  border: 1px solid #ccc;
  padding: 3px 5px 3px 8px;
  border-radius: 4px;
  width: 100%;
}

.error {
  border-color: red;
}

.occupied {
  /* background-color: #f0f0f0; */
  opacity: 0.3;
  pointer-events: none;
}
</style>
